var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "About IST",
      "tabActive": "Certification Status",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Certification Status ")])]), _c('top-image', {
    attrs: {
      "src": "/images/sub/about/status/status-img.png"
    }
  })], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('h4', {
    staticClass: "tit--md font-weight-bold line-height-1 mb-28 mb-lg-40"
  }, [_vm._v(" Certification acquisition status ")]), _c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('certification', {
    attrs: {
      "num": "Quality Management System",
      "src": "/images/sub/about/status/cert2-1.png"
    }
  }, [_vm._v(" ISO 9001:2015 ")]), _c('certification', {
    attrs: {
      "num": "Environmental Management System",
      "src": "/images/sub/about/status/cert2-2.png"
    }
  }, [_vm._v(" ISO 14001:2015 ")]), _c('certification', {
    attrs: {
      "num": "Information Security Management System",
      "src": "/images/sub/about/status/cert2-3-en.png"
    }
  }, [_vm._v(" ISO 27001 : 2013 ")]), _c('certification', {
    attrs: {
      "num": "Health Safety Management System",
      "src": "/images/sub/about/status/cert2-4-en.png"
    }
  }, [_vm._v(" ISO 45001:2018 ")])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('h4', {
    staticClass: "tit--md font-weight-bold line-height-1 mb-28 mb-lg-40"
  }, [_vm._v(" Patent acquisition status ")]), _c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('certification', {
    attrs: {
      "num": "No. 10-0879086",
      "src": "/images/sub/about/status/cert1-1.png"
    }
  }, [_vm._v(" Retainer-Ring for Polishing Wafer ")]), _c('certification', {
    attrs: {
      "num": "No. 10-1123870",
      "src": "/images/sub/about/status/cert1-2.png"
    }
  }, [_vm._v(" Method for Manufacturing Retainer-Ring for Polishing Wafer ")]), _c('certification', {
    attrs: {
      "num": "No. 10-1364089",
      "src": "/images/sub/about/status/cert1-3.png"
    }
  }, [_vm._v(" Retainer-Ring for Polishing Wafer & Method of Manufacturing the Same ")]), _c('certification', {
    attrs: {
      "num": "No. 10-2246289",
      "src": "/images/sub/about/status/cert1-4.png"
    }
  }, [_vm._v(" Reusable Retainer-Ring for Polishing Wafer & Manufacturing ")]), _c('certification', {
    attrs: {
      "num": "No. 10-0879085",
      "src": "/images/sub/about/status/cert1-5.png"
    }
  }, [_vm._v(" Retainer-Ring for Polishing Wafer ")]), _c('certification', {
    attrs: {
      "num": "No. 10-0884236",
      "src": "/images/sub/about/status/cert1-6.png"
    }
  }, [_vm._v(" Retainer-Ring for Polishing Wafer ")]), _c('certification', {
    attrs: {
      "num": "No. 10-2247867",
      "src": "/images/sub/about/status/cert1-7.png"
    }
  }, [_vm._v(" Retainer-Ring Using Friction Welding, Apparatus & Method for Manufacturing Thereof ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }